import { REFERRAL_CODE_KEY } from "@/lib/constants";
import { useEffect } from "react";

const useReferralCode = () => {
  const params = new URLSearchParams(window.location.search);
  const code = params.get("referral_code");

  useEffect(() => {
    if (!code) return;
    sessionStorage.setItem(REFERRAL_CODE_KEY, code);
  }, [window.location.href, code]);
};

export default useReferralCode;
